// extracted by mini-css-extract-plugin
export var statItem = "_ea-1";
export var statsRow = "_ea-0";